// Overlay prevent click
const overlayPreventClick = (function(){

	//options
	const fadeDuration = 800;

	//cache DOM
	const $el = $('#overlay-prevent-click');

	function fadeIn({duration = fadeDuration} = {}){
		return new Promise(resolve => $el.fadeIn(duration, resolve));
	}

	function fadeOut({duration = fadeDuration} = {}){
		return new Promise(resolve => $el.fadeOut(duration, resolve));
	}

	function show(){
		$el.show();
	}

	function hide(){
		$el.hide();
	}

	return {
		fadeIn: fadeIn,
		fadeOut: fadeOut,
		show: show,
		hide: hide
	};

})(); //overlayPreventClick

export {overlayPreventClick};